import camera from './camera'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'
import Stats from 'three/examples/jsm/libs/stats.module'
import * as THREE from 'three'

export const canvas = document.querySelector('#c') // What we draw on
export const clock = new THREE.Clock()
export const container = document.getElementById('container') // Anything we want to display as HTML instead of canvas
export const renderer = new THREE.WebGLRenderer({ canvas })
renderer.setPixelRatio(window.devicePixelRatio)
renderer.setSize(window.innerWidth, window.innerHeight)
renderer.shadowMap.enabled = true
export const scene = new THREE.Scene()
export const stats = new Stats()
stats.domElement.style.position = 'absolute'
stats.domElement.style.top = '0px'
export const textureLoader = new THREE.TextureLoader()

export const controls = new OrbitControls(camera, renderer.domElement)
controls.target.set(0, 2, 0)
controls.update()

export function onWindowResize() {
  camera.aspect = window.innerWidth / window.innerHeight
  camera.updateProjectionMatrix()

  renderer.setSize(window.innerWidth, window.innerHeight)
}
